import {FlexibleLayout} from '@defign/ui'
import classNames from 'classnames/bind'

import Styles from './InsuranceFlexibleLayout.module.scss'

import type {ReactNode} from 'react'

const cx = classNames.bind(Styles)

export default function InsuranceFlexibleLayout({children, header}: {children: ReactNode; header?: ReactNode}) {
    return (
        <FlexibleLayout isFullHeight colorType="gray100" containerClassName={cx('layout')} topElement={header}>
            {children}
        </FlexibleLayout>
    )
}
